/*
 * @Author: liuliangliang liuliangliang@sniffgroup.com
 * @Date: 2024-03-04 10:40:40
 * @LastEditors: shiguang
 * @LastEditTime: 2024-03-12 20:35:57
 * @FilePath: /ckb-official-website-fed/src/container/Culture/components/SectionItem/index.tsx
 * @Description: 文化/内容页
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { atomRoutePathLangPre } from '@/atom/atomRoutePathLangPre';
import useDeviceType, { ENUM_DEVICE_TYPE } from '@/hooks/useDeviceType';
import { CultureContentItem, maskImgH5, maskImgPC } from '../config';
import './sectionCompany.scss';

const SectionItem = (props: CultureContentItem) => {
    const { deviceType } = useDeviceType();
    const routePathLangPre = useAtomValue(atomRoutePathLangPre);

    const nav = useNavigate();
    return (
        <div className="section sectionCompany" style={{ width: '100vw', height: 'calc(var(--vh) * 100)', position: 'relative' }}>
            <div
                style={{ position: 'relative', height: 'calc(var(--vh) * 100)' }}
            >


                <img
                    src={props[`imgUrl${deviceType}`]}
                    className="section-item-img"
                    style={{
                        width: '100vw',
                        height: 'calc(var(--vh) * 100)',
                        objectFit: 'cover'
                    }} alt=""
                />


                <img
                    src={deviceType === ENUM_DEVICE_TYPE.MOBILE ? maskImgH5 : maskImgPC}
                    style={{
                        width: '100%',
                        height: 'calc(var(--vh) * 100)',
                        objectFit: 'cover',
                        position: 'absolute',
                        zIndex: 22,
                        top: 0,
                        left: 0

                    }} alt=""
                />


            </div>

            <div className="content">
                <div className="section-item-title">{props.title()}</div>
                <div className="section-item-desc">
                    {props.desc()}
                </div>
                <div style={{ display: 'flex' }}>
                    <div className="section-item-btn" onClick={() => nav(`/${routePathLangPre}/culture?section=2`)}>
                        {props.btn}
                    </div>
                </div>
            </div>
        </div>
    );


};

export default SectionItem;